export default "__VITE_ASSET__dab66de3__"